<app-checkbox
  [ngModel]="checkboxValue"
  [ngbTooltip]="buildTranslationKey(checkboxValue ? 'unselectAll' : 'selectAll') | translate"
  [placement]="'top'"
  [checkBoxVariant]="'multiselect'"
  (changeManually)="changeSelection($event.checked)"
></app-checkbox>
